import React, { Component } from "react";
import BackButton from "../../component/BackButton";

class ProjectDetailShopistry extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <BackButton />
          <div className="sm-space"></div>
          <div className="project-title text-left">Shopistry</div>
          <div className="sm-space"></div>
          <div className="row">
            <div className="project-info col-lg-3 col-sm-12">
              <div className="project-subheader">Project Summary</div>
              <div className="project-subheader-detail">
                <b>Client: </b>
                Human-Computer Interaction: Principles and Design final project
                <div className="sm-space"></div>
                <b>Role: </b>
                User Researcher and Designer, user testing facilitator and
                observer.
                <div className="sm-space"></div>
                <b>Technology: </b>
                Sketch, Invision
                <div className="sm-space"></div>
              </div>
            </div>
            <div className="project-description col-lg-9 col-sm-12">
              <p>
                Shopistry is a mobile platform that helps mystery shoppers
                perform tasks on-site. The goal of this research is to design an
                app that allows users to complete their tasks during visits
                without appearing suspicious.
                <div className="space"></div>
                <div className="project-subheader">
                  A mystery shopper is provided with a set of questions and is
                  required to complete them by recalling and analyzing
                  observations made during the store visit.
                </div>
                <p className="design-vision">
                  One of the biggest challenges faced by mystery shoppers is the
                  lack of tools to help them efficiently navigate their task
                  lists. They are unable to take notes or capture the store
                  environment directly, as they must remain incognito and behave
                  like regular customers. As part of a design course, we aimed
                  to improve the working conditions of mystery shoppers by
                  developing a more effective solution. We conducted interviews
                  with Daymaker, a mystery shopping company based in Stockholm.
                  At Daymaker, mystery shoppers are required to complete a
                  report after each assignment. However, since this reporting
                  typically occurs after the store visit, there is a risk of
                  missing important details or observations during task
                  submission.
                </p>
                <div className="space"></div>
                <div className="project-subheader">
                  Additional interviews were conducted with individuals who have
                  prior experience working as mystery shoppers.
                </div>
                <p className="ethnographic-observation">
                  A unique finding from our research was that most mystery
                  shoppers are women aged between 20 and 30 years old, with a
                  strong familiarity with technology. Based on these insights,
                  we assumed that designing a mobile application would provide a
                  more efficient and user-friendly solution compared to writing
                  responses elsewhere and submitting them later through a
                  separate form. We analyzed the key aspects of their tasks,
                  including responding to questions and documenting the store
                  environment through photographs.
                </p>
                <div className="space"></div>
                <div className="project-subheader-summary">User Interface</div>
                <div className="sm-space"></div>
                <div>
                  <img
                    className="cover"
                    src={require("../../assets/images/shopistry-1.png")}
                    alt="cover-food-bank"
                  />
                </div>
                <div className="sm-space"></div>
                <p className="user-interface">
                  Since the primary task of the user is to answer questions, we
                  incorporated a task progress bar to align with the visibility
                  of system status design principle. This feature helps users
                  understand their progress and the current state of the system.
                  Additionally, we implemented error prevention mechanisms in
                  the question-skipping feature. The application allows users to
                  skip questions when necessary, and our design ensures that
                  skipped questions do not require mandatory responses, thereby
                  reducing user frustration and improving task flow.
                </p>
                <div className="space"></div>
                <div className="row ">
                  <div className="col-lg-3">
                    <img
                      className="cover"
                      src={require("../../assets/images/shopistry-2.png")}
                      alt="cover-food-bank"
                    />
                  </div>
                  <div className="col-lg-8">
                    <p className="interview">
                      In some situations, a mystery shopper may be interrupted
                      by a shopkeeper while answering questions. To avoid
                      drawing attention and maintain anonymity, the shopper may
                      need to quickly close the application. In Shopistry, we
                      designed a system that allows users to seamlessly return
                      to their previous step upon reopening the app. This
                      feature aligns with the heuristic principle of user
                      control and freedom, enabling users to manage
                      interruptions without losing progress or compromising
                      their task performance.
                    </p>
                    <p>
                      We also designed a homepage that notifies users of pending
                      tasks that need to be completed promptly. This feature
                      helps minimize the user’s memory load by reducing the need
                      to recall which tasks remain unfinished, thereby
                      supporting more efficient task management and cognitive
                      ease.
                    </p>
                  </div>
                </div>
                <div className="sm-space"></div>
                <div className="row">
                  <p className="interview col-lg-4">
                    After submitting a task, the mystery shopper is presented
                    with a completion notification confirming successful
                    submission. They can then navigate to the task status page
                    to review and monitor the progress of their submission.
                  </p>
                  <div className="col-lg-8">
                    <img
                      className="cover"
                      src={require("../../assets/images/shopistry-3.png")}
                      alt="cover-food-bank"
                    />
                  </div>
                </div>
                <div className="sm-space"></div>
                <div className="row">
                  <div className="col-lg-3">
                    <img
                      className="cover"
                      src={require("../../assets/images/shopistry-4.png")}
                      alt="cover-food-bank"
                    />
                  </div>
                  <p className="interview col-lg-8">
                    To ensure continuous user awareness and engagement, the
                    system is designed to notify mystery shoppers of all
                    significant updates. One key example is the success message
                    that appears upon task submission. Beyond confirming
                    successful completion, this message incorporates a
                    call-to-action element, enabling users to directly access
                    their task dashboard. This design decision supports the
                    usability heuristic of system feedback and visibility,
                    allowing users to maintain a clear understanding of their
                    overall project status. By providing immediate access to
                    their task progress and project list, the system enhances
                    transparency, reinforces a sense of accomplishment, and
                    promotes efficient task management.
                  </p>
                </div>
                <div className="sm-space"></div>
                <div className="row">
                  <p className="interview col-lg-6">
                    A single mystery shopper may have multiple ongoing tasks or
                    projects, often involving visits to different stores. On
                    this page, users are provided with a comprehensive overview
                    of all their project statuses. The system categorizes each
                    project into three distinct states: in progress, submitted,
                    and completed, enabling users to easily track and manage
                    their assignments.
                    <br />
                    1. In Progress – Indicates that the project has been
                    accepted or initiated by the mystery shopper but has not yet
                    been submitted to the system
                    <br />
                    2. Submitted – Represents that all assigned tasks have been
                    completed and successfully submitted for review. <br />
                    3. Completed – Signifies that the system has received and
                    reviewed the submitted tasks, and the corresponding payment
                    has been processed.
                  </p>
                  <div className="col-lg-6">
                    <img
                      className="cover"
                      src={require("../../assets/images/shopistry-5.png")}
                      alt="cover-food-bank"
                    />
                  </div>
                </div>
                <div className="space"></div>
                <p className="interview">
                  In this section, key information such as the deadline, store
                  location, project status, and a call-to-action button linking
                  to the task page are prominently displayed to support
                  efficient task management. Based on insights from user
                  testing, we chose to represent deadlines using a countdown
                  format (e.g., “3 days remaining”) rather than explicit
                  calendar dates. Participants found this approach more
                  intuitive, as it reduced the need for mental calculation and
                  minimized cognitive load. The store location is presented as a
                  clickable link that opens directly in Google Maps, enabling
                  users to navigate to the store without manually re-entering
                  the address. Additionally, we provide an overview of the
                  questions assigned to each task, allowing mystery shoppers to
                  access specific questions directly from this page for greater
                  efficiency and ease of use.
                </p>
                <div className="space"></div>
                <div className="project-subheader-summary">User Testing</div>
                <p className="interview">
                  In the test plan, we identified the target user group who
                  would participate in evaluating the design. Specific tasks and
                  subtasks were developed to simulate real user interactions,
                  allowing observers to assess usability, task completion, and
                  overall user experience during the testing session. This
                  structured approach ensured that the evaluation captured both
                  quantitative performance metrics and qualitative behavioral
                  insights.
                </p>
                <p className="interview">
                  The test participants consist of individuals with prior
                  experience as mystery shoppers. A mystery shopper is
                  responsible for evaluating retail environments that involve
                  direct customer interactions. They are assigned specific tasks
                  by an organization to perform during store visits while
                  maintaining the appearance of an ordinary customer. Mystery
                  shoppers exhibit varying levels of technological proficiency,
                  but they are generally familiar with using digital interfaces,
                  as their role requires access to both a computer and a mobile
                  device for completing evaluations. The usability test focuses
                  on the core tasks that mystery shoppers typically perform
                  during a store visit. Participants receive task descriptions
                  outlining the objectives but are not provided with detailed
                  instructions on how to complete them, allowing for the
                  observation of natural user behavior and independent
                  problem-solving. The following section outlines the tasks
                  assigned to participants during the usability testing session:
                  <div className="sm-space"></div>
                  1. Task: Check All Assignments.
                  <br />
                  In this scenario, it is assumed that the user has already
                  logged into the application. Upon launching the app, the user
                  is directed to the home screen, which serves as the main
                  navigation hub. From this screen, the user can view all
                  assigned tasks by selecting the “View My Assignments” button
                  prominently displayed on the interface. Alternatively, this
                  task can also be completed by accessing the burger menu and
                  selecting “Task Progress.” This dual navigation design
                  supports user flexibility and control, allowing users to
                  choose the interaction path that best aligns with their
                  personal preferences and habits.
                  <br />
                  <div className="sm-space"></div>
                  2. Task: Start the H&M Kista Galleria Visit.
                  <br />
                  After logging in, the user is presented with a welcome screen
                  featuring a clear call-to-action button labeled “View Your
                  Assignments.” By selecting this button, the user is redirected
                  to a page displaying their list of assigned visits. From this
                  list, the user can locate and choose the H&M Kista Galleria
                  assignment to begin the visit process. This interaction flow
                  emphasizes clarity and ease of navigation, ensuring that users
                  can seamlessly transition from login to task initiation
                  without confusion.
                  <br />
                  <div className="sm-space"></div>
                  3. Task: Answer the Questionnaire.
                  <br />
                  In this stage, the user engages with the questionnaire
                  interface, where each task is presented with a corresponding
                  description and interaction type. The user can provide
                  responses through multiple input formats — including text
                  fields, binary “Yes”/“No” buttons, and photo uploads to
                  visually document observations. The interface also supports
                  task management actions, allowing users to skip a question
                  (with an accompanying notification to the company), navigate
                  between questions using “Next” and “Previous” buttons, and
                  monitor overall completion progress through a progress bar.
                  Once all required questions have been answered, the user can
                  submit the completed questionnaire directly through the
                  system. This design ensures a structured yet flexible flow,
                  promoting usability, error prevention, and clarity of task
                  status throughout the evaluation process.
                </p>
              </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ProjectDetailShopistry;
